const GA_COOKIE_NAMES = ["_ga", "_gid", "_gat"];
const GA_COOKIE_PREFIXES = ["_ga_", "_gcl"];

const DAY_IN_MS = 24 * 60 * 60 * 1000;

const buildCandidateDomains = (): string[] => {
  const { hostname } = window.location;
  const parts = hostname.split(".").filter(Boolean);
  const domains = new Set<string>([hostname]);

  for (let i = 0; i < parts.length - 1; i += 1) {
    domains.add(`.${parts.slice(i).join(".")}`);
  }

  return Array.from(domains);
};

const expireCookie = (name: string, domain?: string) => {
  const expires = new Date(Date.now() - DAY_IN_MS).toUTCString();
  const domainPart = domain ? `;domain=${domain}` : "";

  document.cookie = `${name}=;expires=${expires};path=/${domainPart}`;
  document.cookie = `${name}=;expires=${expires};path=/${domainPart};Secure`;
  document.cookie = `${name}=;expires=${expires};path=/${domainPart};SameSite=Lax`;
  document.cookie = `${name}=;expires=${expires};path=/${domainPart};Secure;SameSite=None`;
};

export const clearGoogleAnalyticsCookies = () => {
  if (typeof document === "undefined" || typeof window === "undefined") return;

  const rawCookieNames = document.cookie
    .split(";")
    .map((cookiePart) =>
      cookiePart.trim().split("=")[0])
    .filter(Boolean);

  const namesToDelete = rawCookieNames.filter((name) =>
    GA_COOKIE_NAMES.includes(name) || GA_COOKIE_PREFIXES.some((prefix) =>
      name.startsWith(prefix)));

  if (!namesToDelete.length) return;

  const domains = buildCandidateDomains();

  namesToDelete.forEach((name) => {
    expireCookie(name);
    domains.forEach((domain) =>
      expireCookie(name, domain));
  });
};
